import { Component, OnInit,Input} from '@angular/core';
import { Location } from '@angular/common';
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LoadingState } from '../../loading/loading.component';
import { forkJoin } from 'rxjs';
import * as moment from 'moment';
import {PerExecutionService} from '../../../services/per-execution.service';
import { SettingService} from '../../../services/setting.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../../core/components/confirm-dialog/confirm-dialog.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-labour-water-connection-inner-tab',
  templateUrl: './labour-water-connection-inner-tab.component.html',
  styleUrls: ['./labour-water-connection-inner-tab.component.scss']
})
export class LabourWaterConnectionInnerTabComponent implements OnInit {

  @Input() projectId:number; 
  form: FormGroup;
  loading: LoadingState = LoadingState.NotReady;
  waterDocumentList:any = [];
  waterDetails:any = [];
  @Input() approveStatus:any = [];
  dialogRef: MatDialogRef<ConfirmDialogComponent>;

  constructor(
    private location: Location,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private perExecutionService:PerExecutionService,
    public settingService:SettingService
  ) { }

  ngOnInit() {
    //console.log(this.projectId);
    this.form = this.formBuilder.group({
      project:[this.projectId],
      borewell_for_drinking_water:[null,Validators.required],
      quantity:[null,Validators.required],
      depth:[null,Validators.required],
      contractor_name:[null,Validators.required],
      con_contact_number:[null,Validators.required],
      email_id:[null,[Validators.required,Validators.email]],
      con_address:[null,Validators.required],
      latitude:[null],
      longitude:[null],
      requirment_s_date:[null,Validators.required],
      requirment_e_date:[null,Validators.required],
      budgeted_cost:[null,Validators.required],
      executed_cost:[null,Validators.required],
      documents:this.formBuilder.array([
        // this.createDocument()
      ])
    })

    if(this.projectId){
      this.getWaterDetails();
    }
  }

  save()
  {
    if(this.form.valid){
      var water_documents_data = [];
      water_documents_data = this.form.value.documents;
      //console.log(water_documents_data);

      this.loading = LoadingState.Processing

      const data = {
        project: this.projectId,
        borewell_for_drinking_water: this.form.value.borewell_for_drinking_water,
        quantity:this.form.value.quantity,
        depth: this.form.value.depth,
        contractor_name: this.form.value.contractor_name,
        con_contact_number: this.form.value.con_contact_number,
        email_id: this.form.value.email_id,
        con_address: this.form.value.con_address,
        latitude: this.form.value.latitude,
        longitude: this.form.value.longitude,
        requirment_s_date: this.settingService.getProperDate(this.form.value.requirment_s_date).toISOString(),//aa
        requirment_e_date: this.settingService.getProperDate(this.form.value.requirment_e_date).toISOString(),//aa
        budgeted_cost: this.form.value.budgeted_cost,
        executed_cost: this.form.value.executed_cost,
      }
      this.waterDocumentList = [];
      this.perExecutionService.addLabourWaterOffice(data).subscribe(
        res => {
          var forkArray = [];

          water_documents_data.forEach(x => {
              const formData: any = new FormData();
              formData.append("project",this.projectId);
              formData.append("module_id", res.id);
              formData.append("document_name", x.document_name);
              formData.append("document", x.water_document, x.water_document['name']);
              forkArray.push(this.perExecutionService.addLabourWaterDocumentOffice(formData))
          })
          forkJoin(forkArray).subscribe(
            (result: any[]) => {
              // console.log(result)
              result.forEach(y => {
                this.waterDocumentList.push(y)
              })
              
              // this.add_tender_document()
              this.loading = LoadingState.Ready;
            },
            err => {
              this.loading = LoadingState.Ready;
              // console.log(err)
            }
          )
          this.loading = LoadingState.Ready;
          this.toastr.success('Data has been saved','',{
            timeOut: 3000,
            });
        },
        error=>{
          //console.log(error);
          this.loading = LoadingState.Ready;
          this.toastr.error('Something went wrong', '', {
            timeOut: 3000,
            });
        }
      )
     // console.log(data);

    }else
    {
      this.markFormGroupTouched(this.form);
    }
  }


  getWaterDetails(){
    this.perExecutionService.getLabourWaterOffice(this.projectId).subscribe(
      res=>{
        if(res['result'][0]){
          this.waterDetails = res['result'][0];
          //console.log(this.waterDetails);
          this.waterDocumentList = res['result'][0].document_details;
          var start_date = new Date(this.waterDetails['requirment_s_date'])
            this.waterDetails.requirment_s_date = {
              year: start_date.getFullYear(),
              month: start_date.getMonth()+1,
              day: start_date.getDate()
        
            }
            var end_date = new Date(this.waterDetails['requirment_e_date'])
            this.waterDetails.requirment_e_date = {
              year: end_date.getFullYear(),
              month: end_date.getMonth()+1,
              day: end_date.getDate()
              
            }
          this.form.patchValue({
            latitude: this.waterDetails.latitude,
            longitude: this.waterDetails.longitude
          })
          this.waterDetails.budgeted_cost = parseFloat(this.waterDetails.budgeted_cost).toFixed(2);
          this.waterDetails.executed_cost = parseFloat(this.waterDetails.executed_cost).toFixed(2);
        }
        this.loading = LoadingState.Ready;
      },
      error => {
        //console.log(error);
        this.loading = LoadingState.Ready;
        this.toastr.error('Something went wrong', '', {
          timeOut: 3000,
          });
      }
    )
  }

  update(){
    if(this.form.valid){
     // console.log(this.waterDetails);
      var water_documents_data = [];
      water_documents_data = this.form.value.documents;

      if(this.form.value.documents.length > 0){
        var forkArray = [];
        water_documents_data.forEach(x => {
            const formData: any = new FormData();
            formData.append("project", this.projectId);
            formData.append("module_id", this.waterDetails.id);
            formData.append("document_name", x.document_name);
            formData.append("document", x.water_document, x.water_document['name']);
            forkArray.push(this.perExecutionService.addLabourWaterDocumentOffice(formData))
        })
        forkJoin(forkArray).subscribe(
          result => {
            // console.log(result)
            result.forEach(y => {
              this.waterDocumentList.push(y)
            })
           
            // this.add_tender_document();
            this.loading = LoadingState.Ready;
          },
          err => {
            this.loading = LoadingState.Ready;
            // console.log(err)
          }
        )
        this.updateWater();
      }

      else{
        this.updateWater();
      }


    }
  }

  updateWater(){
    if(this.form.valid){
      this.loading = LoadingState.Processing

      const updateData = {
        project: this.projectId,
        borewell_for_drinking_water: this.form.value.borewell_for_drinking_water,
        quantity:this.form.value.quantity,
        depth: this.form.value.depth,
        contractor_name: this.form.value.contractor_name,
        con_contact_number: this.form.value.con_contact_number,
        email_id: this.form.value.email_id,
        con_address: this.form.value.con_address,
        latitude: this.form.value.latitude,
        longitude: this.form.value.longitude,
        requirment_s_date: this.settingService.getProperDate(this.form.value.requirment_s_date).toISOString(),//aa
        requirment_e_date: this.settingService.getProperDate(this.form.value.requirment_e_date).toISOString(),//aa
        budgeted_cost: this.form.value.budgeted_cost,
        executed_cost: this.form.value.executed_cost,
      }

      this.perExecutionService.editLabourWaterOffice(this.waterDetails.id,updateData).subscribe(
        res =>{
          //console.log(res)
         
            this.loading = LoadingState.Ready;
            this.toastr.success('Data has been saved','',{
              timeOut: 3000,
              });
        },
        error =>{
         
            this.loading = LoadingState.Ready;
         
            this.toastr.error('Something went wrong', '', {
              timeOut: 3000,
              });
        }
      )

    }
  }
  

  handleAddressChange(address) {
    // Do some stuff
    //console.log(address)
    var lat = address.geometry.location.lat();
    var lng = address.geometry.location.lng();
    var formattedAddress = address.formatted_address
    
    this.form.patchValue({
      latitude: lat,
      longitude: lng,
      con_address: formattedAddress
    })
  }

  
  createDocument(){
    return this.formBuilder.group({
      document_name: [null, Validators.required],
      document: [null, Validators.required],
      water_document: null
    })
  }

  getFormArrayControl(form) {
    return form.get('documents').controls
  }

  addDocument()
  {
    const control = <FormArray>this.form.controls['documents'];
    control.push(this.createDocument());
  }

  deleteDocument(index:number)
  {
    const control = <FormArray>this.form.controls['documents'];
    control.removeAt(index);
  }

  onSelectFile(event, index){
    //console.log(event.target.files);
    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();
        reader.onload = (event) => {
          // console.log(event.target['result']);
        }
        const control = <FormArray>this.form.controls['documents'];
        control.at(index).patchValue({
          document: event.target.files[0]['name'],
          water_document: event.target.files[0]
        })
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }

  getFile(file: string) {
    var fileName = file.split('.')
    var fileExt = fileName[fileName.length - 1];
    if (fileExt == 'jpg' || fileExt == 'jpeg' || fileExt == 'png') {
      return file;
    }
    else {
      return 'assets/img/pdf.png'
    }
  }

  editDoc(index) {
    this.waterDocumentList[index]['isEdit'] = true
    this.waterDocumentList[index]['isFieldError'] = false
  }

  renameDoc(index) {
    if (this.waterDocumentList[index]['document_name'] == '') {
      this.waterDocumentList[index]['isFieldError'] = true;
    }
    else {
      this.loading = LoadingState.Processing
      this.waterDocumentList[index]['isFieldError'] = false;
      var data = {
        document_name: this.waterDocumentList[index]['document_name']
      }

      
      this.perExecutionService.editLabourWaterDocumentOffice(this.waterDocumentList[index]['id'], data).subscribe(
        res => {
          // console.log(res)
          this.waterDocumentList[index]['isEdit'] = false
          this.loading = LoadingState.Ready
        },
        error => {
          // console.log(error)
          this.loading = LoadingState.Ready
        }
      )
    }
  }

  deleteDoc(index) {
    this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: false
    });

    this.dialogRef.componentInstance.confirmMessage = "Are you sure you want to delete?"

    this.dialogRef.afterClosed().subscribe(result => {
     if(result){
      this.loading = LoadingState.Processing
      this.perExecutionService.delteLabourWaterDocumentOffice(this.waterDocumentList[index]['id']).subscribe(
        res => {
          this.waterDocumentList.splice(index, 1)
          // console.log(res)
          this.loading = LoadingState.Ready
        },
        error => {
          // console.log(error)
          this.loading = LoadingState.Ready
        }
      )
	 }
	 this.dialogRef = null;
	 })

   
  }

  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        control.controls.forEach(c => this.markFormGroupTouched(c));
      }
    });
  }

  isFieldValid(form: FormGroup, field: string) {
    return !form.get(field).valid && (form.get(field).dirty || form.get(field).touched);
  }

  displayFieldCss(form: FormGroup, field: string) {
    return {
      'is-invalid': form.get(field).invalid && (form.get(field).dirty || form.get(field).touched),
      'is-valid': form.get(field).valid && (form.get(field).dirty || form.get(field).touched)
    };
  }

}
